import React from 'react'

import { Typography, Grid, Button, Accordion, AccordionSummary, AccordionDetails, TextField } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import {
    ValidatorForm,
} from "react-material-ui-form-validator";

import { Delete, Save } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { contratacionesEstadoLegalDelete, contratacionesEstadoLegalUpload } from '../../../actions/contrataciones/contratacionesLegales';
import ValidatedDatePicker from '../../compartidos/ValidatedDatePicker';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { useForm } from '../../../hooks/useForm';
import { useDispatch } from 'react-redux';

export const AreaLegal = ({area, estadosLegales, fieldsDisabled}) => {
    const dispatch = useDispatch();

    let datosSeguimientoLegal = {
        idAreaLegal: area.idAreaLegal,
        observacion: "",
        fecha: ""
      };
      console.log(fieldsDisabled)
      const [
        formValues,
        handleInputChange,
        ,
        setearValor
    ] = useForm(datosSeguimientoLegal);

    const submitHandler = (e) => {
        e.preventDefault();
        dispatch(contratacionesEstadoLegalUpload(formValues));
    };

    return (
        <ValidatorForm onSubmit={submitHandler}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Accordion style={{ marginTop: "1rem" }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel2a-content`}
                            id={`panel2a-header`}
                        >
                            <Typography>{area.descripcion}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                {!fieldsDisabled && 
                                    <>
                                        <Grid item xs={2}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <ValidatedDatePicker
                                                    fullWidth
                                                    margin="normal"
                                                    label="Fecha"
                                                    format="dd/MM/yyyy"
                                                    okLabel="Aceptar"
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    maxDate={new Date()}
                                                    value={moment(formValues.fecha).isValid() ? moment(formValues.fecha) : null}
                                                    onChange={(date) => {
                                                        setearValor("fecha", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                    validators={["required"]}
                                                    errorMessages={["Este campo es obligatorio"]}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="observacion"
                                                value={formValues.observacion}
                                                onChange={handleInputChange}
                                                multiline
                                                variant="outlined"
                                                rows={4}
                                                validators={["required"]}
                                                errorMessages={["Este campo es obligatorio"]}
                                            />
                                        </Grid>
                                        <Grid 
                                            item xs={12} 
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                startIcon={<Save />}
                                            >
                                                Guardar seguimiento
                                            </Button>
                                        </Grid>
                                    </>
                                } 
                                <TableGeneric
                                    data={estadosLegales.filter(estado => estado.idAreaLegal === area.idAreaLegal)}
                                    columns={[
                                        {
                                            label: "Observaciones",
                                            id: "observacion",
                                            sort: true
                                        },
                                        {
                                            label: "Fecha",
                                            id: "fecha",
                                            sort: true,
                                            customBody: (item) => moment(item.fecha).format("DD/MM/YYYY")
                                        },
                                        {
                                            label: "Usuario",
                                            id: "usuarioAlta.userName",
                                            sort: true
                                        },
                                        {
                                            label: "",
                                            id: "",
                                            customBody: (item) => 
                                                <Button 
                                                    color="primary" 
                                                    size={"large"} 
                                                    startIcon={<Delete />} 
                                                    onClick={() => { dispatch(contratacionesEstadoLegalDelete(item.idEfectorEstadoLegal))}} 
                                                    disabled={fieldsDisabled}
                                                />
                                        }
                                    ]}
                                />
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
